/* global BigInt */

// Exact representation/quantity validation only. No money, tax, fee or price calculation.
// Non-integer JS numbers are deliberately excluded from the new decimal DTO.
const parse = (value, { precision = 28, scale = 28, signed = false } = {}) => {
  if (typeof value === "number") {
    if (!Number.isSafeInteger(value)) return null;
    value = String(value);
  }
  if (typeof value !== "string" || value.length > precision + scale + 3
    || !/^-?\d+(?:\.\d+)?$/.test(value) || (!signed && value.startsWith("-"))) return null;
  const negative = value.startsWith("-");
  const [whole, fraction = ""] = value.replace(/^-/, "").split(".");
  const integer = whole.replace(/^0+(?=\d)/, "");
  const tail = fraction.replace(/0+$/, "");
  const digits = (integer + tail).replace(/^0+/, "") || "0";
  if (tail.length > scale || digits.length > precision) return null;
  return { coefficient: BigInt(digits) * (negative ? -1n : 1n), scale: tail.length };
};
const format = ({ coefficient, scale }) => {
  const negative = coefficient < 0n;
  const digits = String(negative ? -coefficient : coefficient).padStart(scale + 1, "0");
  const text = scale ? `${digits.slice(0, -scale)}.${digits.slice(-scale)}` : digits;
  return (negative ? "-" : "") + text;
};
const compare = (a, b) => {
  const scale = Math.max(a.scale, b.scale);
  const left = a.coefficient * 10n ** BigInt(scale - a.scale);
  const right = b.coefficient * 10n ** BigInt(scale - b.scale);
  return left < right ? -1 : left > right ? 1 : 0;
};
const multiplyQuantity = (a, b, limits) => {
  let coefficient = a.coefficient * b.coefficient;
  let scale = a.scale + b.scale;
  if (coefficient === 0n) return { coefficient: 0n, scale: 0 };
  while (scale && coefficient % 10n === 0n) { coefficient /= 10n; scale -= 1; }
  if (scale > limits.derivedScale || String(coefficient).length > limits.derivedPrecision) return null;
  const value = { coefficient, scale };
  return compare(value, parse(limits.maxMagnitude)) > 0 ? null : value;
};
const storedDecimal = (value, precision, scale) => {
  const parsed = parse(value, { precision, scale });
  if (!parsed || compare(parsed, { coefficient: 10n ** BigInt(precision - scale), scale: 0 }) >= 0) return null;
  return parsed;
};
module.exports = { parse, format, compare, multiplyQuantity, storedDecimal };
